import React, { useState, useEffect } from 'react';
import './CtAlarmas.css';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridToolbarExport } from '@mui/x-data-grid-pro';

function CtAlarmas(props) {
    var getBrowserWidth = function () {

        if (window.innerWidth < 1023) {
            return "xs";
        }
    };
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code, ct } = props;
    const [filtrarActivas, setFiltrarActivas] = useState(false);
    var [textoBotonActivas, setTextoBotonActivas] = useState('Mostrar solo activas');
    var [CT, setCT] = useState([]);
    var [activas, setActivas] = useState(0);
    var [filas, setFilas] = useState([]);
    const variablesAPedir = "id,idCT,name,alarmId,severity,active,description,startDate,endDate";
    let number = 0;

    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque + "&idCT=" + ct + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataCT) => { setCT(await dataCT.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/inverters?idSolarFarm=" + idParque + "&idCT=" + ct + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataCT) => { setCT(await dataCT.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number, ct]);

    //Filtrar las alarmas y solo mostrar las activas
    function botonFiltrarActivas() {
        if (textoBotonActivas === 'Mostrar solo activas') {
            setTextoBotonActivas('Mostrar todo');
            setFiltrarActivas(true);
        } else {
            setTextoBotonActivas('Mostrar solo activas');
            setFiltrarActivas(false);
        }
    };

    /*Tamaño para las columnas de la tabla*/
    var anchoPantalla, columnasTabla, ocupadoPorcentaje, pixelesOcupados, pixelesRestantes, tamañoColum, tamColumPeque, tamañoDescri, tamañoFechas;
    if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
        /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
        anchoPantalla = window.screen.width;
        columnasTabla = 8;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = (pixelesRestantes / columnasTabla) - 0.3;
        tamColumPeque = tamañoColum / 2;
        tamañoDescri = tamañoColum + (tamColumPeque * 3);
        tamañoFechas = tamañoColum + (tamColumPeque / 2);
    } else {
        /*Tamaño para las columnas de la tabla, si es en movil o tablet*/
        tamañoColum = 100;
        tamColumPeque = 90;
        tamañoDescri = 320;
        tamañoFechas = 160;
    }

    /**Controlar el reajuste de tamaño de pantalla */
    window.addEventListener("resize", () => {
        if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
            /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
            anchoPantalla = window.screen.width;
            columnasTabla = 8;
            ocupadoPorcentaje = 30;
            pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
            pixelesRestantes = anchoPantalla - pixelesOcupados;
            tamañoColum = (pixelesRestantes / columnasTabla) - 0.3;
            tamColumPeque = tamañoColum / 2;
            tamañoDescri = tamañoColum + (tamColumPeque * 2);
            tamañoFechas = tamañoColum + (tamColumPeque / 2);
        } else {
            /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
            tamañoColum = 100;
            tamColumPeque = 90;
            tamañoDescri = 360;
            tamañoFechas = 160;
        }
    });

    const columnas = [{ field: 'id', headerName: 'ID', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', hide: true, cellClassName: 'cell-ctAlarma-id' },
    { field: 'device', headerName: 'Dispositivo', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma-dispositivo' },
    { field: 'alarma', headerName: 'Alarma', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma' },
    { field: 'severidad', headerName: 'Severidad', width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma-severidad' },
    { field: 'descripcion', headerName: 'Descripción', width: tamañoDescri, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma-descripcion' },
    { field: 'estado', headerName: 'Estado', width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma-estado' },
    { field: 'inicio', headerName: 'Fecha Inicio', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma-inicio' },
    { field: 'fin', headerName: 'Fecha Fin', width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-ctAlarma-fin' }];

    useEffect(() => {
        var array = [];
        var activas_aux = 0;
        CT.map((datoINV) => {
            const { id, idCT, name, alarmId, severity, active, description, startDate, endDate } = datoINV;
            var auxState;
            if (active === true) {
                auxState = "Activa";
                activas_aux++;
            } else {
                auxState = "Inactiva";
            }
            array.push({ id: id, device: name, alarma: alarmId, severidad: severity, descripcion: description, estado: auxState, inicio: startDate, fin: endDate });
        })
        if (filtrarActivas === true) {
            array = array.filter(a => { return a.estado === "Activa" });
        }
        setFilas(array.reverse()); //Queremos que las mas nuevas aparezcan antes
        setActivas(activas_aux);
    }, [CT, filtrarActivas]);
    var mobil = getBrowserWidth();

    if (mobil === 'xs') {
        return (
            <div className='container-fluid' style={{ marginTop: '15px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a id='active-ct-alarms-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                <div className='col' id='div-table-alarms-ct'>
                                    <DataGridPro sx={{
                                        width: '100%',
                                        align: 'center',
                                        ".MuiDataGrid-columnHeaders": { overflowX: 'scroll' },
                                        ".MuiDataGrid-row": { display: 'block', width: '100%', paddingLeft: '5%', marginLeft: '0%' },
                                        ".MuiDataGrid-virtualScrollerContent": { width: 'auto !important' },
                                        ".MuiDataGrid-virtualScrollerRenderZone": { width: ' -webkit-fill-available' },
                                        ".MuiDataGrid-main": { overflow: 'none', },
                                        ".MuiDataGrid-virtualScroller": { marginTop: '56px !important' },
                                        ".MuiDataGrid-cell": { width: 'fit-content', border: 'none', position: 'relative', paddingLeft: '50%', marginTop: '.5%' },
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red', },
                                        '& .super-app-theme--Inactiva': { color: 'green', }
                                    }}
                                        rows={filas} columns={columnas} pagination pageSize={5} autoHeight={true} /*checkboxSelection*/
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "Alarmas" } } }}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick disableColumnResize='true'
                                        getRowHeight={() => 'auto'}
                                        getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='container-fluid' style={{ marginTop: '15px' }}>
                <div className='row'>
                    <div className='col'>
                        <div className='row'>
                            <div className='col-auto'>
                                <h5>Alarmas</h5>
                            </div>
                            <div className='col-auto'>
                                Activas: <strong>{activas}</strong>
                            </div>
                            <div className='col-auto'>
                                <a id='active-ct-alarms-button' onClick={botonFiltrarActivas}>{textoBotonActivas}</a>
                            </div>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                <div className='col' id='div-table-alarms-ct'>
                                    <DataGridPro sx={{
                                        width: '100%',
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red', },
                                        '& .super-app-theme--Inactiva': { color: 'green', }
                                    }}
                                        rows={filas} columns={columnas} pagination pageSize={12} autoHeight={true}
                                        componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "AlarmasCT" + ct } } }}
                                        components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick getRowClassName={(params) => `super-app-theme--${params.row.estado}`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default CtAlarmas;